import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import NomsTable from './_NomsTable.js';
import EditNom from './_EditNom.js';
const URI = ApiEndpoint + 'configuration/';

const Noms = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [openModal, setOpenModal] = useState(false);
  const [noms, setNoms] = useState(false);
  const [idNomEdit, setIdNomEdit] = useState(false);
  const handleClose = () => {
    setOpenModal(false);
    getNoms();
  };

  const getNoms = async () => {
    console.log('entre a getCitiesList');
    setNoms(null);

    httpClient('GET', URI + 'noms/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setNoms(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getNoms();
  }, []);
  return (
    <>
      {' '}
      {noms && (
        <NomsTable
          noms={noms}
          setIdNomEdit={setIdNomEdit}
          setOpenModal={setOpenModal}
        ></NomsTable>
      )}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={(idNomEdit > 0 ? 'Editar' : 'Agregar') + ' Nom'}
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditNom idNom={idNomEdit} closeModal={handleClose}></EditNom>
        </MyModal>
      )}
    </>
  );
};

export default Noms;
